export const PATH_LOGIN = 'login';
export const PATH_FORGOT_PASSWORD = 'forgot-password';
